import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import VentureEmbed from './venture/VentureEmbed';
import { ActingBar } from './AccountSwitch';
import { settleSession } from './sessionGuard';
import { startVersionWatch } from './versionWatch';

// 끝난 로그인 토큰 정리 — 전환 토큰이 끝났으면 내 계정으로 · 다 끝났으면 로그인 화면(2026-10-28 「세션 만료 · 다시 시도」 막다른 화면)
settleSession();
// 새로 배포되면 열려 있던 탭에 「새 버전 · 새로고침」 알림(2026-11-02 — 아침에 연 탭에 낮 배포 기능이 안 보이던 것)
startVersionWatch();

// 올댓벤처스 어드민 안의 벤처인증 화면(allthatventures.com/rv/ · 2026-10-17) — 로움 화면 한 벌을 그대로
const embedVenture = /^\/rv(\/|$)/.test(window.location.pathname);

const root = ReactDOM.createRoot(document.getElementById('root'));
// 직원 계정으로 전환해 쓰는 동안 어느 화면에서든 아래 띠(2026-10-26)
root.render(embedVenture ? <VentureEmbed /> : <><App /><ActingBar /></>);
